import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const STORAGE_KEY = 'glowytics_v10_sections';

function getStoredState(sectionKey) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed[sectionKey];
  } catch { return undefined; }
}

function setStoredState(sectionKey, isOpen) {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    parsed[sectionKey] = isOpen;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
  } catch {}
}

export function CollapsibleSection({ title, icon: Icon, defaultOpen = false, sectionKey, children }) {
  const stored = sectionKey ? getStoredState(sectionKey) : undefined;
  const [isOpen, setIsOpen] = useState(stored !== undefined ? stored : defaultOpen);

  useEffect(() => {
    if (sectionKey) setStoredState(sectionKey, isOpen);
  }, [sectionKey, isOpen]);

  return (
    <div className="accordion-section mb-3">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`accordion-header w-full ${isOpen ? 'accordion-header-open' : ''}`}
      >
        <div className="flex items-center gap-2.5">
          {Icon && <Icon size={16} className="text-blue-500" />}
          <span className="text-sm font-semibold text-gray-800">{title}</span>
        </div>
        <motion.div animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.2 }}>
          <ChevronDown size={16} className="text-gray-400" />
        </motion.div>
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
            style={{ overflow: 'hidden' }}
          >
            <div className="accordion-body p-4">
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
